export const useClampable = (
  target: Ref<HTMLElement | null>,
  lines: number | undefined | null,
) => {
  const isExpanded = ref(false);
  const isExpandable = ref(false);

  const applyLineClamp = () => {
    if (!target.value) return;

    target.value.style.display = "-webkit-box";
    target.value.style.webkitBoxOrient = "vertical";
    target.value.style.overflow = "hidden";
    target.value.style.webkitLineClamp = lines ? lines.toString() : "unset";
  };

  const checkExpandable = () => {
    if (!target.value || !lines) return;

    isExpandable.value = target.value.scrollHeight > target.value.clientHeight;
  };

  const startResizeObserver = () => {
    if (target.value) {
      const resizeObserver = new ResizeObserver(() => {
        checkExpandable();
      });

      resizeObserver.observe(target.value);
    }
  };

  const expand = () => {
    if (!target.value) return;

    target.value.style.webkitLineClamp = "unset";
    isExpanded.value = true;
  };

  const collapse = () => {
    applyLineClamp();
    isExpanded.value = false;
  };

  const toggle = () => {
    if (isExpanded.value) {
      collapse();
    } else {
      expand();
    }
  };

  onMounted(() => {
    if (lines) {
      nextTick(() => {
        applyLineClamp();
        checkExpandable();
        startResizeObserver();
      });
    }
  });

  onUpdated(() => {
    if (lines) {
      nextTick(() => {
        checkExpandable();
      });
    }
  });

  return {
    isExpanded,
    isExpandable,
    expand,
    collapse,
    toggle,
  };
};
